import React from "react";
import socialLinks from '../../utils/socialLinks';

const MobileMenuSection = () => {
    return (
        <>
            <p className="description">
                Real-time market support. Proven Nifty options strategies. Built by a trader, for traders.
            </p>
            <ul className="navbar-top-left rbt-information-list justify-content-start">
                <li>
                    <a href="mailto:hello@example.com">
                        <i className="feather-mail" />
                        venkateshan@daytradingtactics.in
                    </a>
                </li>
                <li>
                    <a href="#">
                        <i className="feather-phone" />
                        (+91) 7808780874
                    </a>
                </li>
            </ul>
            <nav className="mainmenu-nav">
                <ul className="mainmenu">
                    <li className="with-megamenu has-menu-child-item position-static">
                        <a href="#">
                            Home 
                        </a>
                    </li>
                    <li className="with-megamenu has-menu-child-item">
                        <a href="#courses">
                            Courses 
                        </a>
                    </li>
                    <li className="has-dropdown has-menu-child-item">
                        <a href="#">
                            Dashboard
                           
                        </a>
                    </li>
                </ul>
            </nav>
            <div className="mobile-menu-bottom">
                <div className="rbt-btn-wrapper mb--20">
                    <a className="rbt-btn btn-border-gradient radius-round btn-sm hover-transform-none w-100 justify-content-center text-center" href="#">
                        <span>Enroll Now</span>
                    </a>
                </div>
                <div className="social-share-wrapper">
                    <span className="rbt-short-title d-block">Find With Us</span>
                    <ul className="social-icon social-default transparent-with-border justify-content-start mt--20">
                        <li><a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer"><i className="feather-facebook" /></a></li>
                        <li><a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer"><i className="feather-twitter" /></a></li>
                        <li><a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer"><i className="feather-youtube" /></a></li>
                        <li><a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer"><i className="feather-instagram" /></a></li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default MobileMenuSection;
